const equityAppraisalValuesTemplates = `<!DOCTYPE html>
<html>
  <head>
  </head>
  <body>
    <div id="appraisalValues">
      <div class="heading"><h6>Appraisal &nbsp; Value &nbsp; (Values &nbsp; in &nbsp;{{currency}} )</h2></div>
      <table>
        <tr>
          <th></th>
          <th></th>
          <th>% Change</th>
          <th>Effective &nbsp; Date &nbsp; Of Value</th>
          <th>Schedule &nbsp; - &nbsp;N</th>
        </tr>
        <tr>
          <td class="leftAlign">Current &nbsp; Appraisal &nbsp; Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{  currentAppraisalValue}}</td>
          <td></td>
          <td>{{currentDate}}</td>
          <td class ="rightAlign">{{currencySymbol}}{{  scheduleNValue}}</td>
        </tr>
        <tr>
          <td class="leftAlign">Last &nbsp; Appraised &nbsp; Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{  lastAppraisedValue}}</td>
          <td class ="rightAlign"> {{ currentPercentageChange}}</td>
          <td>{{lastDate}}</td>
          <td></td>
        </tr>
        <tr>
          <td class="leftAlign">Annual &nbsp; Appraised &nbsp; Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{  annualAppraisedValue}}</td>
          <td class ="rightAlign"> {{ annualPercentageChange}}</td>
          <td>{{annualDate}}</td>
          <td></td>
        </tr>
        <tr>
          <!-- Additional rows with 9 columns -->
        </tr>
      </table>
    </div>
  </body>
</html>
`;

export default equityAppraisalValuesTemplates;


// #equityAppraisalValues > table,
//       th,
//       td {
//         border: none;
//         padding-top: 10px;
//       }
//       #equityAppraisalValues > table {
//         width: 100%;
//         border-radius: 3px !important;
//       }
      
//       #equityAppraisalValues > th,
//       td {
//         padding: 15px;
//       }

//       #equityAppraisalValues {
//         width: 100%;
//         border: 0.5px solid #263746;
//         border-radius: 3px;
//       }

//       #equityAppraisalValues > .heading {
//         margin: 0 !important;
//         background-color: #263746;
//         color: #fff;
//         padding: 10px;
//       }

//       #equityAppraisalValues > th > .leftAlign {
//         align-items: left !important;
//         justify-content: left !important;
//         text-align: left !important;
//       }